export default __webpack_public_path__ + "static/media/stroller.2f835f21.png";